import React from 'react';
import { useTranslation } from 'react-i18next';
import { FooterProps } from '../types';
import '../styles/Footer.css';

const Footer: React.FC<FooterProps> = ({ className = '' }) => {
  const { t } = useTranslation();

  return (
    <footer className={`footer ${className}`}>
      <div className="footer-bottom">
        <p>{t('footer.copyright')}</p>
      </div>
    </footer>
  );
};

export default Footer;
